// @TODO: fine-tune copy
/*
 * Ryan O'Dowd
 * 2024-03-02
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import ContactForm from '@website/components/ContactForm';
import DownloadLinks from '@website/components/DownloadLinks';
import GoogleAppointmentButton from './GoogleAppointmentButton';
import {
  Link,
} from 'react-router';
import PricingMatrix from '@website/components/PricingMatrix';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import WebPageStub from '@website/containers/WebPageStub';
import WebsiteSection from '@website/components/WebsiteSection';
import getStyles from './styles';
import hooks from '@hooks';

// @TODO: update all copy in here to be about schools, not fundraising
const Schools = () => {
  const styles = hooks.useStyles(getStyles);

  const betaOn = hooks.useTypedSelector((state) => state.userSettings.beta_on);

  const _renderBulletPoint = (title, body, lightBackground) => { // @TODO: abstract this with fundraising (and make its own component?)
    return <Text style={[styles.bulletPoint, lightBackground && styles.lightBackgroundText]}><Text style={[styles.title, lightBackground && styles.lightBackground]}>{title}</Text>{body}</Text>;
  };

  return (
    <WebPageStub>
      <WebsiteSection
        isDarkBackground={true}
        title='Wrinkly in the classroom'
      >
        <Text style={styles.subtitle}>{"Create Bible goals for students using Wrinkly's learning management system for schools.  Designed specifically with Scripture memorization in mind, Wrinkly also helps with reading plans and custom curriculum development."}</Text>
        <GoogleAppointmentButton />
        {/* @TODO: start free trial button */}
      </WebsiteSection>

      <WebsiteSection
        title='Built for teachers'
      >{/* @TODO: make sure this looks good on mobile */}
        <View style={styles.inner}>
          <View style={styles.sideBySide}>
            <View style={styles.section}>
              {_renderBulletPoint('Create', 'Develop custom curriculum for your students; assign Bible readings, verse lessons, memory tests, and custom content.', true)}
              {_renderBulletPoint('Track', 'Manage classroom membership, set deadlines, follow student progress, and generate reports to maximize student support and to encourage parent involvement.', true)}
              {_renderBulletPoint('Fundraise', <Text style={styles.contactText}>Raising money for a campus project, scholarships, missions, or another cause?  Wrinkly can help track donors and participants to raise money for every verse memorized.  See <Link to='/fundraising'>our fundraising page</Link> for more information.</Text>, true)}
            </View>
            <View style={styles.section}>
              <Text style={styles.contactHeader}>Contact us</Text>
              <View style={styles.contactWrapper}>
                <ContactForm
                  leadingText={<Text style={styles.contactText}>{"If you are a school teacher, administrator, or parent interested in using Wrinkly in the classroom, we'd love to hear from you.  Please "}<a target='_blank' rel='noopener noreferrer' href='https://calendar.app.google/EgbgBGZps4fi2UAg9'>schedule a demo</a>{', fill out '}<a target='_blank' rel='noopener noreferrer' href='https://docs.google.com/forms/d/e/1FAIpQLSc9ABMzGoHVFEo3NFD7UJIQNMs6LAlSW6HAxoxVYV-xsIwRkA/viewform?usp=sf_link'>this survey</a>{', or use the form below.  We appreciate your input!'}</Text>}
                  textStyles={styles.contactText}
                  // @TODO: should have more space after leadingText
                />
              </View>
            </View>
          </View>
        </View>
      </WebsiteSection>

      <WebsiteSection
        isDarkBackground={true}
      >{/* @TODO: make sure this looks good on mobile */}
        <View style={styles.downloadCtaWrapper}>
          <h2>Download Wrinkly</h2>
          <DownloadLinks />
        </View>
      </WebsiteSection>

      {betaOn &&
        <WebsiteSection title='Pricing'>{/* @TODO: make sure this looks good on mobile */}
          <PricingMatrix />
        </WebsiteSection>
      }

    </WebPageStub>
  );
};

export default Schools;
